import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes, IconVariants } from '../../../components/foundations/Icon';
import Tooltip from '../../../components/molecules/Tooltip';
import { getUserData } from '../../../selectors/user';
import { shouldShowAskSingularAI } from '../../utils';
import { prefetchPromptSuggestions } from '../../../chatView/hooks/usePromptSuggestions';
import useAskSingularAI from './useAskSingularAI';
import AskSingularAICommandBar from './AskSingularAICommandBar';
import { TRANSLATION_PREFIX } from './consts';
import css from './style.css';

function AskSingularAILauncher() {
    const buttonRef = useRef(null);
    const { isOpen, isStarting, prompt, onType, pickSuggestion, submit, open, close } = useAskSingularAI();

    useEffect(() => prefetchPromptSuggestions(), []);

    return (
        <>
            <Tooltip
                titleTranslationKey={`${TRANSLATION_PREFIX}.SHORTCUT`}
                position="bottom"
                style={{ display: 'flex' }}
            >
                <button ref={buttonRef} type="button" className={css.launchButton} onClick={open}>
                    <Icon name="sparkles" size={IconSizes.SMALL} variant={IconVariants.WHITE} interactive={false} />
                    <Translate id={`${TRANSLATION_PREFIX}.LAUNCH`} />
                </button>
            </Tooltip>
            {isOpen && (
                <AskSingularAICommandBar
                    anchorRef={buttonRef}
                    prompt={prompt}
                    isStarting={isStarting}
                    onType={onType}
                    pickSuggestion={pickSuggestion}
                    submit={submit}
                    close={close}
                />
            )}
        </>
    );
}

function AskSingularAIButton() {
    const userData = useSelector(getUserData) || {};

    if (!userData.email || !shouldShowAskSingularAI(userData)) {
        return null;
    }

    return <AskSingularAILauncher />;
}

export default AskSingularAIButton;
